import React from "react";
import { Row, Col } from "react-bootstrap";
import "../css/SectionFour.css";

function SectionFour() {
  return (
    <div className="container-sectionfour">
      <hr className="garispemisah-sectionfour" />
      <h1 className="judul-sectionfour">
        Cara menjadwalkan meeting dengan professional
      </h1>
      <p className="kalimat-sectionfour">Let’s see right now</p>
      <Row className="container-carapesan-sectionfour">
        <Col className="container-kolom-sectionfour">
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/079-www_vv0lu1.png"
            alt="bukasitus"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">Buka situs Promeet.com</p>
        </Col>
        <Col>
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/178-search_pxpu2w.png"
            alt="caripro"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">Cari Professional </p>
        </Col>
        <Col>
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/158-clipboard-1_ewmxmz.png"
            alt="jadwal"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">Jadwalkan Pertemuan</p>
        </Col>
      </Row>
      <div>
        <img
          src="https://res.cloudinary.com/def4tydoe/image/upload/v1604810189/cara%20pesan/line_xrdupi.png"
          alt="line"
          className="garis-carapesan-sectionfour"
        />
      </div>
      <Row className="container-carapesan-sectionfour">
        <Col>
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/205-deal_lhvgud.png"
            alt="verifikasi"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">Perjanjian Diverifikasi</p>
        </Col>
        <Col>
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/105-meeting-8_wxsvbm.png"
            alt="meeting"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">Meeting </p>
        </Col>
        <Col>
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807707/cara%20pesan/Desain_tanpa_judul-removebg-preview_m97hj1.png"
            alt="circle"
            className="img-circle-sectionfour"
          />
          <img
            src="https://res.cloudinary.com/def4tydoe/image/upload/v1604807484/cara%20pesan/144-idea-3_wapmed.png"
            alt="insight"
            className="img-vector-sectionfour"
          />
          <p className="judul-carapesan-sectionfour">
            Dapatkan insight dan manfaat
          </p>
        </Col>
      </Row>
      <div>
        <img
          src="https://res.cloudinary.com/def4tydoe/image/upload/v1604810189/cara%20pesan/line_xrdupi.png"
          alt="line"
          className="garis-carapesan-sectionfour"
        />
      </div>
    </div>
  );
}

export default SectionFour;
